// Mock data for Claim A Trademark website

export const businessInfo = {
  name: "Claim A Trademark",
  email: "info@claimatrademark.com",
  phone: "+1 (123) 123-4567",
  address: "1551 N Tustin Ave #710, Santa Ana, CA 92705"
};

export const pricingPlans = [
  {
    id: 1,
    name: "Essentials",
    price: "$45",
    subtitle: "+ Federal Filing Fee",
    features: [
      "Case Review",
      "Case Filing",
      "Basic Search",
      "State E-Filing",
      "Trademark Secured"
    ],
    note: "(Govt. filing fee not included)",
    recommended: false
  },
  {
    id: 2,
    name: "Enhanced",
    price: "$149",
    subtitle: "+ Federal Filing Fee",
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter"
    ],
    note: "(Govt. filing fee not included)",
    recommended: false
  },
  {
    id: 3,
    name: "Deluxe",
    price: "$299",
    subtitle: "+ Federal Filing Fee",
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter",
      "Trademark Monitoring",
      "Complete Documentation",
      "Digital File",
      "Dedicated Case Manager"
    ],
    note: "(Govt. filing fee not included)",
    recommended: true
  },
  {
    id: 4,
    name: "Platinum",
    price: "$349",
    subtitle: "+ Federal Filing Fee",
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter",
      "Trademark Monitoring",
      "Complete Documentation",
      "Digital File",
      "Dedicated Case Manager",
      "High Approval Rate",
      "Comprehensive Search Report",
      "High Priority Service",
      "Cease & Desist Letter"
    ],
    note: "(Govt. filing fee not included)",
    recommended: false
  }
];

export const trademarkServices = [
  {
    id: 1,
    title: "Trademark Search & Analysis",
    description: "Comprehensive search of existing trademarks to ensure your brand is unique and registrable with the USPTO.",
    icon: "Search"
  },
  {
    id: 2,
    title: "Federal Trademark Filing",
    description: "Complete preparation and filing of your trademark application with the United States Patent and Trademark Office.",
    icon: "FileText"
  },
  {
    id: 3,
    title: "Office Action Response",
    description: "Expert handling of any USPTO office actions or objections to keep your application moving forward.",
    icon: "AlertCircle"
  },
  {
    id: 4,
    title: "Trademark Monitoring",
    description: "Ongoing monitoring of new trademark filings to protect your registered mark from infringement.",
    icon: "Shield"
  },
  {
    id: 5,
    title: "Cease & Desist Letters",
    description: "Professional legal correspondence to stop unauthorized use of your trademark by competitors.",
    icon: "Mail"
  },
  {
    id: 6,
    title: "Trademark Renewal",
    description: "Timely filing of maintenance documents to keep your trademark registration active and protected.",
    icon: "RefreshCw"
  }
];

export const registrationProcess = [
  {
    step: 1,
    title: "Consultation & Comprehensive Search",
    description: "We begin with a detailed consultation to understand your brand protection needs. Our experts conduct an exhaustive search of federal and state trademark databases, common law sources, and domain registrations to identify any potential conflicts. This comprehensive analysis ensures your trademark has the best chance of approval and helps you avoid costly rejections or future disputes."
  },
  {
    step: 2,
    title: "Professional Application & USPTO Filing",
    description: "Our experienced trademark attorneys meticulously prepare your application with precise legal descriptions, accurate classifications, and compelling specimens of use. We ensure every detail meets USPTO requirements and strategically position your application for success. Once perfected, we electronically file your application with the United States Patent and Trademark Office and provide you with complete documentation and filing confirmation."
  },
  {
    step: 3,
    title: "Monitoring, Response & Registration",
    description: "We actively monitor your application throughout the entire examination process, tracking its progress and responding promptly to any office actions or examiner objections. Our attorneys craft persuasive legal arguments to overcome any obstacles. Upon approval and successful publication, we guide you through final registration, ensuring your trademark is officially registered and your brand receives full nationwide legal protection."
  }
];

export const industries = [
  { 
    name: "Technology & Software", 
    icon: "Laptop",
    description: "Protecting innovative software brands, SaaS platforms, mobile apps, tech startups, and digital products with comprehensive trademark strategies tailored to the fast-paced technology sector."
  },
  { 
    name: "E-Commerce & Retail", 
    icon: "ShoppingCart",
    description: "Securing brand identity for online stores, marketplace sellers, retail businesses, and consumer goods companies with trademark protection crucial for Amazon Brand Registry and e-commerce success."
  },
  { 
    name: "Food & Beverage", 
    icon: "Coffee",
    description: "Registering trademarks for restaurants, food products, beverage brands, catering services, and culinary businesses to protect unique brand names, logos, and distinctive packaging in competitive markets."
  },
  { 
    name: "Fashion & Apparel", 
    icon: "Shirt",
    description: "Defending fashion brands, clothing lines, accessory designers, and apparel companies against counterfeits and copycats through robust federal trademark registration and enforcement strategies."
  },
  { 
    name: "Healthcare & Wellness", 
    icon: "Heart",
    description: "Protecting medical practices, wellness brands, healthcare services, fitness companies, and health product manufacturers with trademark registration that ensures credibility and brand integrity in sensitive industries."
  },
  { 
    name: "Professional Services", 
    icon: "Briefcase",
    description: "Securing trademarks for consulting firms, legal practices, accounting services, real estate agencies, and professional service providers to establish market authority and prevent competitor confusion."
  },
  { 
    name: "Entertainment & Media", 
    icon: "Tv",
    description: "Registering trademarks for production companies, content creators, media outlets, entertainment venues, and creative agencies to protect valuable intellectual property in the entertainment industry."
  },
  { 
    name: "Manufacturing", 
    icon: "Factory",
    description: "Safeguarding industrial brands, product manufacturers, equipment suppliers, and production companies with trademark protection essential for B2B relationships, distribution networks, and market positioning."
  }
];

export const benefits = [
  {
    title: "Exclusive Brand Rights Nationwide",
    description: "Federal trademark registration grants you exclusive rights to use your trademark throughout the entire United States in connection with your goods or services. This means no other business in your industry can legally use a confusingly similar mark, protecting your brand from copycats and competitors. These exclusive rights extend across all 50 states, regardless of where you actually conduct business, providing comprehensive territorial protection that state registration or common law rights simply cannot match.",
    icon: "Award"
  },
  {
    title: "Powerful Legal Protection & Presumption",
    description: "A federally registered trademark creates a legal presumption of your ownership and your exclusive right to use the mark nationwide. This presumption significantly strengthens your position in any trademark disputes, shifting the burden of proof to challengers. Federal registration also gives you the right to bring infringement lawsuits in federal court, access to stronger remedies including statutory damages and attorney's fees, and the ability to stop infringing imports at the border through U.S. Customs and Border Protection.",
    icon: "Shield"
  },
  {
    title: "Increased Business & Brand Value",
    description: "Registered trademarks are valuable intangible assets that significantly increase your overall business valuation. Investors, lenders, and potential buyers view federally registered trademarks as proof of brand strength and market position. This intellectual property can be licensed for additional revenue streams, used as collateral for financing, and factored into company valuations during mergers, acquisitions, or investment rounds. A strong trademark portfolio often represents one of a company's most valuable assets.",
    icon: "TrendingUp"
  },
  {
    title: "Enhanced Credibility & Trust",
    description: "The ® symbol (which can only be used with federally registered trademarks) signals to customers, partners, and competitors that you're a legitimate, established business serious about protecting your brand. This symbol builds immediate trust and credibility with consumers, who associate registered trademarks with quality, reliability, and permanence. Professional use of the ® symbol differentiates you from less established competitors and conveys that your business is here to stay, making customers more confident in choosing your products or services.",
    icon: "BadgeCheck"
  },
  {
    title: "E-Commerce & Marketplace Protection",
    description: "Federal trademark registration is essential for protecting your brand on online marketplaces like Amazon, eBay, Etsy, and others. With a registered trademark, you can enroll in programs like Amazon Brand Registry, which provides powerful tools to prevent counterfeiters and unauthorized sellers from listing under your brand name. You gain the ability to quickly remove infringing listings, control your brand content, and prevent hijackers from damaging your reputation. Without federal registration, you have very limited recourse against online infringement.",
    icon: "ShoppingBag"
  },
  {
    title: "Domain Name Recovery Rights",
    description: "Federal trademark registration significantly strengthens your ability to recover domain names that infringe on your trademark through the Uniform Domain Name Dispute Resolution Policy (UDRP) and Anticybersquatting Consumer Protection Act (ACPA). With a registered trademark, you can file complaints against cybersquatters who register domain names identical or confusingly similar to your mark in bad faith. This protection extends to new domain extensions and international domains, helping you maintain consistent brand presence online and prevent consumer confusion caused by infringing websites.",
    icon: "Globe"
  }
];

export const faqs = [
  {
    question: "What is a trademark and why do I need one?",
    answer: "A trademark is a word, phrase, symbol, or design that identifies and distinguishes your goods or services from others. Registering your trademark with the USPTO provides nationwide protection, exclusive rights to use the mark, and legal advantages in disputes. It prevents competitors from using similar marks that could confuse customers and dilute your brand."
  },
  {
    question: "How long does the trademark registration process take?",
    answer: "The entire trademark registration process typically takes 8-12 months from filing to registration. This includes the initial USPTO review (3-4 months), publication for opposition (30 days), and final registration. However, if there are office actions or objections, the process may take longer. We monitor your application throughout and handle any issues promptly."
  },
  {
    question: "What's the difference between ™ and ®?",
    answer: "The ™ symbol can be used immediately when you claim trademark rights, even before registration. The ® symbol can only be used after your trademark is officially registered with the USPTO. Using ® without registration is illegal and can result in penalties. Once registered, you should use ® to notify others of your federal registration and maximize protection."
  },
  {
    question: "How much does trademark registration cost?",
    answer: "Our service fees range from $45 to $349 depending on the package you choose. Additionally, USPTO government filing fees range from $250-$350 per class of goods/services. Most businesses file in 1-2 classes. We provide transparent pricing with no hidden fees and help you choose the right package for your needs."
  },
  {
    question: "Can my trademark application be rejected?",
    answer: "Yes, the USPTO can issue office actions rejecting or objecting to your application for various reasons including likelihood of confusion with existing marks, descriptiveness, or improper classification. However, our comprehensive search and expert preparation significantly reduce rejection risk. If an office action is issued, our attorneys will respond professionally to overcome objections."
  },
  {
    question: "Do I need to register my trademark in every state?",
    answer: "No, federal trademark registration with the USPTO provides protection across all 50 states. State registration only protects your mark within that specific state and offers limited benefits. We recommend federal registration for comprehensive, nationwide protection, especially if you do business online or plan to expand."
  },
  {
    question: "What can I trademark?",
    answer: "You can trademark brand names, slogans, logos, product names, service names, and even sounds or colors in certain cases. The mark must be distinctive and used in commerce. Generic or purely descriptive terms typically cannot be registered. Our experts will evaluate your mark's registrability during the free consultation."
  },
  {
    question: "How long does trademark protection last?",
    answer: "Federal trademark registration lasts 10 years and can be renewed indefinitely in 10-year increments, as long as you continue using the mark in commerce. However, you must file a Declaration of Use between years 5-6 after registration. We offer monitoring and renewal services to ensure your trademark remains protected."
  }
];

export const whyChooseUs = [
  {
    title: "USPTO Filing Experts",
    description: "Our team consists of experienced trademark attorneys and legal specialists with extensive knowledge of federal trademark law, USPTO procedures, and trademark examination guidelines. We stay current with the latest regulatory changes and best practices to provide you with cutting-edge trademark protection strategies. Our expertise spans all trademark classes and industries, ensuring your application is handled by professionals who understand both the legal complexities and your specific business needs.",
    icon: "GraduationCap"
  },
  {
    title: "1000+ Trademarks Filed",
    description: "With over 1,000 successful trademark registrations completed across diverse industries nationwide, we bring proven experience to every case. Our portfolio includes trademarks for startups, Fortune 500 companies, e-commerce brands, professional services, and everything in between. This extensive track record means we've encountered and successfully resolved virtually every trademark challenge, from complex office actions to multi-class applications, giving you confidence in our ability to protect your brand.",
    icon: "Users"
  },
  {
    title: "High Success Rate",
    description: "Our meticulous approach to trademark registration results in significantly higher approval rates compared to DIY filings or less experienced services. We achieve this through comprehensive pre-filing searches that identify potential conflicts early, precise application drafting that anticipates examiner concerns, strategic classification decisions that maximize protection, and expert responses to office actions. Our attention to detail and deep USPTO knowledge minimize delays and increase your chances of successful registration.",
    icon: "Target"
  },
  {
    title: "Transparent Pricing",
    description: "We believe in complete pricing transparency with no hidden fees or surprise charges. Our clearly defined service packages show exactly what you'll pay upfront, including all our professional fees. We provide detailed explanations of government filing fees, which are separate and paid directly to the USPTO. You'll receive a comprehensive breakdown of all costs before moving forward, allowing you to budget accurately and make informed decisions about your trademark protection investment.",
    icon: "DollarSign"
  },
  {
    title: "Dedicated Support",
    description: "Every client is assigned a dedicated case manager who serves as your personal point of contact throughout the entire trademark registration process. Your case manager provides regular status updates, answers your questions promptly, explains complex legal concepts in plain language, and ensures you're never left wondering about your application's progress. This personalized approach means you receive the attention and communication you deserve, with someone who knows your case intimately and is invested in your success.",
    icon: "Headphones"
  },
  {
    title: "Fast Processing",
    description: "We understand that time matters when protecting your brand. Our streamlined processes and efficient workflows enable us to prepare and file your trademark application quickly without sacrificing quality or thoroughness. Most applications are prepared and filed within 24-48 hours of receiving your information and payment. This rapid turnaround gets your filing date established as soon as possible, which is crucial since trademark rights are generally determined by who files first. Fast processing today means better protection tomorrow.",
    icon: "Zap"
  }
];

export const trustSignals = {
  trademarksRegistered: "1000+",
  successRate: "98%",
  clientSatisfaction: "Excellent",
  averageProcessingTime: "24 Hours"
};

// Mock form submission
export const submitContactForm = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Form submitted:", formData);
      resolve({ success: true, message: "Thank you! We'll contact you within 24 hours." });
    }, 1000);
  });
};
